import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Util from 'utility';
import EvaluationPanelContents from 'components/EvaluationPanel/EvaluationPanelContents';

function EvaluationPanel({ beforeContent, wholeDay, mainStyle, quickResults, evaluationCollapsedAtStart, onRecommendedFoodAdded, className }) {
    const data = useSelector(state => state);
    const profileId = data.profileId;
    const prevProfileIdRef = useRef(profileId);

    useEffect(() => {
        if (!wholeDay) return;
        const prevId = prevProfileIdRef.current;
        prevProfileIdRef.current = profileId;
        if (prevId !== profileId) {
            Util.doLoadDayEvaluation(profileId);
        }
    });

    return (
        <EvaluationPanelContents
            beforeContent={beforeContent}
            wholeDay={wholeDay}
            results={data.evaluationResults.results}
            ddd={data.evaluationResults.ddd}
            style={{order:3}}
            mainStyle={mainStyle}
            quickResults={quickResults}
            evaluationCollapsedAtStart={evaluationCollapsedAtStart}
            onRecommendedFoodAdded={onRecommendedFoodAdded}
            className={className}
        />
    );
}

export default EvaluationPanel;
